<ng-container>
  <div class="app-container">
    <dl-header isDesktop="true"></dl-header>
    <div class="main-page">
      <router-outlet page></router-outlet>
    </div>
    <dl-footer></dl-footer>
  </div>
</ng-container>
